import { useEffect, useState } from "react";
import { getToken } from "../utils/auth";
import configData from "../config.json";

export default function useAdminPermission() {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const token = getToken();
    if (!token) return;

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };

    fetch(`${configData.SERVER_URL}/Permission`, { headers })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setIsAdmin(Boolean(data.auth_user));
      })
      .catch((err) => {
        console.error("Error fetching permission:", err);
      });
  }, []);

  return isAdmin;
}
